// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DLy_C07HOhQvQbYHrY8T{margin:0}.xKv1am7V7Y5zpuNaei2h{align-items:center;height:32px;padding-left:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `DLy_C07HOhQvQbYHrY8T`,
	"labelDropdown": `xKv1am7V7Y5zpuNaei2h`
};
export default ___CSS_LOADER_EXPORT___;
